import { defineMessages } from 'react-intl';
import type { MessageDescriptor } from 'react-intl';

import { PackingExceptionType } from './packing-exception-type';

export const packingExceptionTypeMessages = defineMessages({
  wrongItem: {
    defaultMessage: 'Wrong Item',
    description: 'Packing Exception value for Wrong Item to show in Orders Grid',
    id: '/Xii/d',
  },
  missingItem: {
    defaultMessage: 'Missing Item',
    description: 'Packing Exception value for Missing Item to show in Orders Grid',
    id: 'PWdkCl',
  },
  damagedInventory: {
    defaultMessage: 'Damaged Inventory',
    description: 'Packing Exception value for Damaged Inventory to show in Orders Grid',
    id: 'rD25nq',
  },
  packagingIssue: {
    defaultMessage: 'Packaging Issue',
    description: 'Packing Exception value for Packaging Issue to show in Orders Grid',
    id: '71QYlR',
  },
  other: {
    defaultMessage: 'Other',
    description: 'Packing Exception value for Other to show in Orders Grid',
    id: 'tAmLI9',
  },
});

export const packingExceptionTypeToLabel: Record<string, MessageDescriptor> = {
  [PackingExceptionType.WrongItem]: packingExceptionTypeMessages.wrongItem,
  [PackingExceptionType.MissingItem]: packingExceptionTypeMessages.missingItem,
  [PackingExceptionType.DamagedInventory]: packingExceptionTypeMessages.damagedInventory,
  [PackingExceptionType.PackagingIssue]: packingExceptionTypeMessages.packagingIssue,
  [PackingExceptionType.Other]: packingExceptionTypeMessages.other,
};
